import { TableColumn } from "@/components/Table/Table";

import { ListPerson } from "../../schema/list";

export const GetIrlColumns = (ts: (key: string) => string) => {
	const columns: TableColumn[] = [];

	columns.push({
		title: ts("branchesInEuropeanUnion"),
		width: "fit-content",
		uid: "branchesInEuropeanUnion",
		hideable: true,
		moveable: true,
		show: true,
		render: (row: ListPerson) => <div>{row?.branchesInEuropeanUnion}</div>,
	});

	columns.push({
		title: ts("branchesInEasternGermany"),
		width: "fit-content",
		uid: "branchesInEasternGermany",
		hideable: true,
		moveable: true,
		show: true,
		render: (row: ListPerson) => <div>{row?.branchesInEasternGermany}</div>,
	});

	columns.push({
		title: ts("branchesInSaxony"),
		width: "fit-content",
		uid: "branchesInSaxony",
		hideable: true,
		moveable: true,
		show: true,
		render: (row: ListPerson) => <div>{row?.branchesInSaxony}</div>,
	});

	columns.push({
		title: ts("branchesWorldwide"),
		width: "fit-content",
		uid: "branchesWorldwide",
		hideable: true,
		moveable: true,
		show: true,
		render: (row: ListPerson) => <div>{row?.branchesWorldwide}</div>,
	});

	return columns;
};
